import React, { useMemo, useState } from "react";
import {Name, Created_at, Active, Options} from "./AreaCol";

const useAreaCols = (area, handleSetEditArea, handleSetDeleteArea) => {
    return useMemo(() => [
        {
            Header: "Código",
            accessor: "code_key",
            filterable: false,
            Cell: (cellProps) => {
                return <Name {...cellProps} />;
            },
        },
        {
            Header: "Area",
            accessor: "name",
            filterable: false,
            Cell: (cellProps) => {
                return <Name {...cellProps} />;
            },
        },
        {
            Header: "Titular",
            accessor: "titular",
            filterable: false,
            Cell: (cellProps) => {
                return <Name {...cellProps} />;
            },
        },
        {
            Header: "Fecha Alta",
            accessor: "create_at_f",
            filterable: false,
            Cell: (cellProps) => {
                return <Created_at {...cellProps} />;
            },
        },
        {
            Header: "Status",
            accessor: "active",
            filterable: false,
            Cell: (cellProps) => {
                return <Active {...cellProps} />;
            },
        },
        {
            Header: "Opciones",
            accessor: "options",
            filterable: false,
            Cell: (cellProps) => {
                return <Options {...cellProps} onEdit={handleSetEditArea} onDelete={handleSetDeleteArea} />;
            },
        }
    ],[]);  
}
export {useAreaCols}